import React, { useState } from 'react';
import {
  Toolbar,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
//import { MUTATE_UPDATE, MUTATE_DELETE } from '../../api/mutate-actions.js';
// import { mutate } from "swr";
import ListPaper from './paper-list.js';
import EditFormDialog from './dialog-edit-form.js';
// import SearchBeforeCreateDialog from "./dialog-search-before-create.js";
import ConfirmBeforeDeleteDialog from './dialog-confirm-before-delete.js';

const ListEditComponent = (props) => {


  const [selectedItem, setselectedItem] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editData, setEditData] = useState({})
  const [isCreating, setIsCreating] = useState(false)
  // const [existingMatches, setExistingMatches] = useState()
  // const [openExistingDialog, setOpenExistingDialog] = useState(false)
  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false)

  const emptyItem = {}
  const createHandler = props.createHandler
  const updateHandler = props.updateHandler
  const deleteHandler = props.deleteHandler
  const editFormObjectLabel=props.objectLabel?props.objectLabel:"Data"


  const useGetList=props.useGetList


  const queryResult = useGetList()

  if (queryResult.isLoading || !queryResult.data) {
    return (
      <Box sx={{ flexGrow: 1, maxWidth: 752 }}>
        <Skeleton variant="rectangular" sx={{minHeight: 300}} />
      </Box>
    )
  }

  // console.log(`in list edit component`)

  const handleCreateClick = () => {
    console.log(`in handleCreateClick`)
    //create is just an edit on a blank (empty) item

    handleEditClick(emptyItem, true)
  }

  const handleEditClick = (data, isCreating=false) => {
    // set the selected item
    console.log(`in handleEditClick`)
    setIsCreating(isCreating)
    setselectedItem(data);
    // set the data to edit
    setEditData(data)
    // open the edit item dialog window
    setOpenEditDialog(true);
  };

  const handleDelete = (data) => {
    // set the selected item
    setselectedItem(data);
    // open the delete confirmation dialog
    setOpenDeleteConfirmDialog(true);
  }



  const handleSave = (data) => {
    console.log(`in handleSave, isCreating=${isCreating}`)
    // search before saving, and if no existing data or user asks to proceed, then save the data
    if(isCreating){
      createHandler(data)
    }else{
      updateHandler(data)
    }
    setOpenEditDialog(false)
    // handleSaveWithSearch(data)
  }




  const onProceedDelete = () => {
    // user has been asked to confirm the delete, and still wants to proceed with delete

    // call handler to delete the data
    deleteHandler(selectedItem)//.then((response) => {
      //after save, reload the list
      // forceListReload()
    //}

    //)
    //close the delete confirm dialog
    setOpenDeleteConfirmDialog(false)
  }

  const onCancelDelete = () => {
    // user has been asked to confirm the delete, and canceled out of the delete

    //close the delete confirm dialog
    setOpenDeleteConfirmDialog(false)
  }

  return (
    <div>
      <Box sx={{ flexGrow: 1, maxWidth: 752 }}>
        <ListPaper>
          <Toolbar>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleCreateClick}>
              Add {editFormObjectLabel}
            </Button>
          </Toolbar>
          <props.editList {...props} showEdit={true} showDelete={true} data={queryResult.data} handleEditClick={handleEditClick} handleDelete={handleDelete} />
        </ListPaper>
      </Box>
      <EditFormDialog title={"Edit "+editFormObjectLabel} form={props.editForm} open={openEditDialog} data={editData} onCancel={() => setOpenEditDialog(false)} onSubmit={handleSave} />
      {/* <SearchBeforeCreateDialog open={openExistingDialog} list_element={props.editList} existing_data={existingMatches} onProceed={onProceedExisting} onCancel={onCancelExisting} /> */}
      <ConfirmBeforeDeleteDialog open={openDeleteConfirmDialog} list_element={props.editList} data={selectedItem} confirmMessage={props.deleteConfirmMessage} onProceed={onProceedDelete} onCancel={onCancelDelete} />
    </div>
  );
};

export default ListEditComponent;
